import 'cleave.js/dist/addons/cleave-phone.us'
import * as React from 'react'

import TextField, { defaultTextFieldProps } from './BaseTextField'
import { ITextFieldProps } from './types'

interface IProps extends ITextFieldProps {
  onChange: (value: string) => void
}

const cleaveOptions = {
  delimiter: '-',
  phone: true,
  phoneRegionCode: 'US',
}

function PhoneTextField(props: IProps) {
  const { onChange, ...moreProps } = props

  return (
    <TextField
      {...moreProps}
      autoComplete="tel-national"
      cleaveOptions={cleaveOptions}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    />
  )
}

PhoneTextField.defaultProps = defaultTextFieldProps

export default React.memo(PhoneTextField)
